import { createBrowserRouter } from "react-router-dom";
import Login from "@/pages/Login/Login";
import { books } from "@/assets/books";
import SignUp from "@/pages/SignUp/SignUp";
import Home from "@/pages/Home/Home";
import Layout from "@/components/Layout/Layout";
import Leaderboard from "@/pages/Leaderboard/Leaderboard";
import ForgotPassword from "@/pages/ForgotPassword/ForgotPassword";
import Watchlist from "@/pages/Watchlist/Watchlist";
import TrendingStock from "@/pages/TrendingStock/TrendingStock";
import Settings from "@/pages/Settings/Settings";
import ManageNotifications from "@/pages/Settings/subpage/ManageNotifications";
import ProfileWrapper from "./ProfileWrapper";
import Purchased from "@/pages/Purchased/Purchased";
import SavedPost from "@/pages/SavedPost/SavedPost";
import Wallet from "@/pages/Wallet/WalletPage";
import Confirmation from "@/pages/Confirmation/Confirmation";
import PostWrapper from "./PostWrapper";
import ChangePassword from "@/pages/Settings/subpage/ChangePassword";
import Stock from "@/pages/Stock/Stock";
import ContactUs from "@/pages/ContactUs/ContactUs";
import Drafts from "@/pages/Drafts/Drafts";
import YourAccount from "@/pages/Settings/subpage/YourAccount";
import AccountInformation from "@/pages/Settings/subpage/AccountInformation/AccountInformation";
import Premium from "@/pages/Settings/subpage/Premium";
import WalletSettings from "@/pages/Settings/subpage/WalletSettings";
import WithdrawalAddresses from "@/pages/Settings/subpage/WithdrawalAddresses";
import DeactivateYourAccount from "@/pages/Settings/subpage/DeactivateYourAccount";
import PrivacyPolicy from "@/pages/PrivacyPolicy/PrivacyPolicy";
import LikePrice from "@/pages/Settings/subpage/LikePrice";
import Subscription from "@/pages/Settings/subpage/Subscription";
import ConfirmPassword from "@/pages/Settings/subpage/ConfirmPassword/ConfirmPassword";
import ProtectedAccountRoute from "./ProtectedAccountRoute";
import PrivateRoute from "./PrivateRoute";
import ChangeUsername from "@/pages/Settings/subpage/ChangeUsername";
import ChangeEmail from "@/pages/Settings/subpage/ChangeEmail";
import Notifications from "@/pages/Settings/subpage/Notifications";
import Faq from "@/pages/FAQ/Faq";
import ComingSoon from "@/pages/ComingSoon/ComingSoon";
import Conversations from "@/pages/Conversations/Conversations";

export const router = createBrowserRouter([
  {
    path: books.home,
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      {
        path: books.savedPost,
        element: (
          <PrivateRoute>
            <SavedPost />
          </PrivateRoute>
        ),
      },
      { path: books.leaderboard, element: <Leaderboard /> },
      { path: books.profile, element: <ProfileWrapper /> },
      { path: books.post, element: <PostWrapper /> },
      {
        path: books.watchlist,
        element: (
          <PrivateRoute>
            <Watchlist />
          </PrivateRoute>
        ),
      },
      {
        path: books.purchased,
        element: (
          <PrivateRoute>
            <Purchased />
          </PrivateRoute>
        ),
      },
      { path: books.trending, element: <TrendingStock /> },
      {
        path: books.wallet,
        element: (
          <PrivateRoute>
            <Wallet />
          </PrivateRoute>
        ),
      },
      {
        path: books.conversations,
        element: (
          <PrivateRoute>
            <Conversations />
          </PrivateRoute>
        ),
      },
      { path: books.privacyPolicy, element: <PrivacyPolicy /> },
      { path: books.comingSoon, element: <ComingSoon /> },
      { path: books.faq, element: <Faq /> },
      { path: books.stock, element: <Stock /> },
      {
        path: books.drafts,
        element: (
          <PrivateRoute>
            <Drafts />
          </PrivateRoute>
        ),
      },
      {
        path: books.contactUs,
        element: <ContactUs />,
      },
      {
        path: books.settings,
        element: (
          <PrivateRoute>
            <Settings />
          </PrivateRoute>
        ),
        children: [
          {
            path: books.yourAccount,
            element: <YourAccount />,
            children: [
              {
                path: books.settingsAccount,
                element: (
                  <ProtectedAccountRoute>
                    <AccountInformation />
                  </ProtectedAccountRoute>
                ),
              },
              {
                path: books.changeUsername,
                element: (
                  <ProtectedAccountRoute>
                    <ChangeUsername />
                  </ProtectedAccountRoute>
                ),
              },
              {
                path: books.changeEmaill,
                element: (
                  <ProtectedAccountRoute>
                    <ChangeEmail />
                  </ProtectedAccountRoute>
                ),
              },
              { path: books.settingsChangePassword, element: <ChangePassword /> },
              { path: books.deactivateYourAccount, element: <DeactivateYourAccount /> },
              { path: books.confirmPassword, element: <ConfirmPassword /> },
            ],
          },
          {
            path: books.notifications,
            element: <Notifications />,
            children: [{ path: books.manageNotifications, element: <ManageNotifications /> }],
          },
          {
            path: books.premium,
            element: <Premium />,
            children: [
              { path: books.likePrice, element: <LikePrice /> },
              { path: books.subscription, element: <Subscription /> },
            ],
          },
          {
            path: books.walletSettings,
            element: <WalletSettings />,
            children: [{ path: books.withdrawalAddresses, element: <WithdrawalAddresses /> }],
          },
        ],
      },
    ],
  },
  {
    path: books.login,
    element: <Login />,
  },
  {
    path: books.signUp,
    element: <SignUp />,
  },
  {
    path: books.forgotPassword,
    element: <ForgotPassword />,
  },
  {
    path: "/confirmation/:type",
    element: <Confirmation />,
  },
]);
